import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { Lightbox } from 'ngx-lightbox';
import { NgxSpinnerService } from 'ngx-spinner';
import { VgAPI } from 'videogular2/core';
import * as OT from '@opentok/client';

import { AlertService, ProctorService, OpentokService } from '../_services';
import { Globals } from '../_helpers';
import { SearchFilterPipe } from '../_pipes';
import { NgxCarousel } from 'ngx-carousel';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-proctor',
    templateUrl: './proctor.component.html',
    providers: [OpentokService]
})


export class ProctorComponent implements OnInit, OnDestroy {

    pagetitle: string = '';
    batch_name: string = '';
    exam_name: string = '';
    exam_date;
    statusMsg: string = '';
    localData = {};
    localBatch = {};
    localExam = {};
    loading = false;
    submitted = false;
    returnUrl: string;
    inProgress: number;
    dispalyData = [];
    infos: any;
    vidalbum: any;
    isStudent = false;
    videoIndex: number = 0;
    infoIndex: number = 0;
    videoSrc: string = '';
    infoSrc: string = '';
    infoTitle: string = '';
    name: string = '';
    mobile: string = '';
    email: string = '';
    query: string = '';
    aadhar: string = '';
    date: string = '';
    latlong: string = ''
    location: string = '';
    imageSrc: string = '/assets/images/proctor-img.jpg';
    TOKEN = '';
    SESSION_ID = '';
    preload: string = 'auto';
    api: VgAPI;
    exam_id: number = 0;

    private _albums: Array<any> = [];
    private _videoalbums: Array<any> = [];

    session: OT.Session;
    streams: Array<OT.Stream> = [];
    streaming: OT.Stream;
    changeDetectorRef: ChangeDetectorRef;
    @ViewChild('subscriberDiv') subscriberDiv: ElementRef;
    @ViewChild("videoPlayer") videoplayer: ElementRef;

    public carouselOne: NgxCarousel;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private proctorService: ProctorService,
        private alertService: AlertService,
        private globals: Globals,
        private _lightbox: Lightbox,
        private spinner: NgxSpinnerService,
        private ref: ChangeDetectorRef,

        private opentokService: OpentokService
    ) { this.changeDetectorRef = ref; }

    link
    batchid

    ngOnInit() {
        this.localData = JSON.parse(localStorage.getItem('currentUser'));
        this.localBatch = JSON.parse(localStorage.getItem('localBatch'));
        this.localExam = JSON.parse(localStorage.getItem('localExam'));

        this.link = this.localData['link']
        this.batchid = this.localData['batchId']

        if (this.link == undefined || this.link == null) {
            if (this.localData['is_proctoring'] != 1)
                this.router.navigateByUrl('/login');

        }


        var type = this.route.snapshot.paramMap.get("type");
        if (type == 'students') {
            this.isStudent = true;
            this.pagetitle = 'Student';
            this.getStudentDetailsByBatch();

        }

        else if (type == 'assessors') {
            this.isStudent = false;
            this.pagetitle = 'Assessor';
            this.getAssessorDetailsByBatch();
        }

        this.batch_name = this.localBatch['batch_name'];
        this.exam_name = this.localBatch['exam_name'];
        this.exam_date = this.localBatch['exam_date'];
        //this.exam_id = this.localBatch['exam_id'];

        this.carouselOne = {
            grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
            slide: 1,
            // speed: 400,
            // interval: 4000,
            // point: true,
            load: 2,
            touch: true,
            loop: true,
            custom: 'banner'
        }
    }
plink;
    private getStudentDetailsByBatch() {
        this.spinner.show();
        this.submitted = true;
        this.proctorService.getStudents(this.globals.root_url, this.localData['usercode'], this.localExam['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {

                        this.dispalyData = data.students;
                        //this.plink = "https://mypanel.pareekshn.com/ams/proctoring.html?id="+data.student_id+","+this.localExam['exam_id'];
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else {
                        this.loading = false;
                        this.globals.statusOpen(data.status, '/exams');
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
    }

    private getAssessorDetailsByBatch() {
        this.spinner.show();
        this.submitted = true;
        this.proctorService.getAssessor(this.globals.root_url, this.localData['usercode'], this.localExam['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.dispalyData = data.assessor;
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else {
                        this.loading = false;
                        this.globals.statusOpen(data.status, '/exams');
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
    }

    albumData: any

    public imgGallery(entity_id: number, gallary_type: string) {
        this.spinner.show();
        this.submitted = true;
        this.proctorService.getImagesGallary(this.globals.root_url, this.localData['usercode'], entity_id, gallary_type, this.localExam['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {

                        // if (gallary_type == 'students') {
                        this.albumData = data.album;

                        // }
                        // else {
                        //     // this._albums =  data.album;

                        //     var albumData = data.album;
                        //     var length = albumData.length;
                        //     for (let i = 1; i <= length; i++) {

                        //         var album = {
                        //             src: albumData[i - 1].src,
                        //             caption: albumData[i - 1].comment ? albumData[i - 1].comment : 'No Comments',
                        //         };
                        //         this._albums.push(album);
                        //     }

                        // }



                        /*for (let i = 1; i <= 4; i++) {
                            const src = 'demo/img/image' + i + '.jpg';
                            const caption = 'Image ' + i + ' caption here';
                            const thumb = 'demo/img/image' + i + '-thumb.jpg';
                            const album = {
                                src: src,
                                caption: caption,
                                thumb: thumb
                            };
                     
                            this._albums.push(album);
                        }*/
                        this.open(0, gallary_type);
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else {
                        this.loading = false;
                        this.globals.statusOpen(data.status);
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
    }

    image
    comment
    prev = true
    next = true

    public open(index: number, gallary_type): void {
        // open lightbox
        // if (typeof this._albums != 'undefined' && this._albums.length > 0)
        //     this._lightbox.open(this._albums, index);
        document.getElementsByTagName('body')[0].style.overflow = "hidden"
        this.videoIndex = 0;
        this.image = this.albumData[this.videoIndex].src;
        this.comment = this.albumData[this.videoIndex].comment;
        if (this.comment == null) {
            this.comment = "No Comments"
        }
        else {
            this.comment = this.albumData[this.videoIndex].comment;
        }


        let image = document.getElementById('image');
        image.style.display = 'block';

    }



    public prevImage() {
        if (this.videoIndex == 0) {
            this.prev = false

        } else if (this.videoIndex > 0) {
            --this.videoIndex;
            this.image = this.albumData[this.videoIndex].src;
            this.comment = this.albumData[this.videoIndex].comment;
            if (this.comment == null) {
                this.comment = "No Comments"
            }
            else {
                this.comment = this.albumData[this.videoIndex].comment;
            }
        }
    }

    public nextImage() {
        let totalImage = (this.albumData.length) - 1;
        if (this.videoIndex < totalImage) {
            ++this.videoIndex;
            this.image = this.albumData[this.videoIndex].src;
            this.comment = this.albumData[this.videoIndex].comment;
            if (this.comment == null) {
                this.comment = "No Comments"
            }
            else {
                this.comment = this.albumData[this.videoIndex].comment;
            }


        }
    }
    public close(): void {
        // close lightbox programmatically
        this._lightbox.close();
    }

    onPlayerReady(api: VgAPI) {
        this.api = api;
    }
    public videoGallery(entity_id: number, gallary_type: string) {
        this.spinner.show();
        this.submitted = true;
        this.proctorService.getVideoGallary(this.globals.root_url, this.localData['usercode'], entity_id, gallary_type, this.localExam['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this._videoalbums = data.album;

                        this.videoOpen(0);
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else {
                        this.loading = false;
                        this.globals.statusOpen(data.status);
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
    }

    public videoOpen(index: number) {
        document.getElementsByTagName('body')[0].style.overflow = "hidden"
        this.videoIndex = 0;
        this.videoSrc = this._videoalbums[this.videoIndex].src;

        // console.log(this.videoSrc)
        let vmodal = document.getElementById('vmodal');
        // console.log(vmodal)
        vmodal.style.display = 'block';
    }

    public prevVideo() {
        if (this.videoIndex > 0) {
            --this.videoIndex;
            this.videoSrc = this._videoalbums[this.videoIndex].src;

            // console.log(this.videoSrc)
        }
    }

    public nextVideo() {
        let totalVideo = (this._videoalbums.length) - 1;
        if (this.videoIndex < totalVideo) {
            ++this.videoIndex;
            this.videoSrc = this._videoalbums[this.videoIndex].src;


        }
    }

    public customModalClose(modal_id: string) {
        document.getElementsByTagName('body')[0].style.overflow = "auto";
        let modal = document.getElementById(modal_id);
        this.videoplayer.nativeElement.pause();
        this.videoplayer.nativeElement.currentTime = 0;
        modal.style.display = 'none';
    }



    public getInfo(entity_id: number, info_type: string) {
        this.spinner.show();
        this.submitted = true;
        this.proctorService.getInformation(this.globals.root_url, this.localData['usercode'], entity_id, info_type, this.localExam['exam_id'])
            .pipe(first())
            .subscribe(
                data => {

                    if (data.code == 1000) {

                        this.infos = data.info;

                        this.infoOpen();
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else {
                        this.loading = false;
                        this.globals.statusOpen(data.status);
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;

                    this.spinner.hide();
                }
            );
    }

    public infoOpen() {

        document.getElementsByTagName('body')[0].style.overflow = "hidden";
        let infomodal = document.getElementById('infomodal');
        infomodal.style.display = 'block';
    }


    public prevInfo() {

        if (this.infoIndex > 0) {
            --this.infoIndex
            this.infoSrc = this.infos[this.infoIndex];
            console.log(this.infoSrc)

        }


    }

    public nextInfo() {

        let totalinfo = (this.infos.length) - 1;
        if (this.infoIndex < totalinfo) {
            ++this.infoIndex;
            this.infoSrc = this.infos[this.infoIndex];
            console.log(this.videoSrc)

        }

    }

    public vivaAnswer(id: number) {
        this.router.navigate(['/viva', id]);
    }

    public practical(id: number,) {

        this.router.navigate(['/practical', id]);
    }

    public videos() {

        this.router.navigateByUrl('/videos');
    }
    subscriber

    public liveStreemimg(student_id: number, isVivaDone: number) {
        if (isVivaDone == 2 || isVivaDone == 3) {
            return false;
        }
        else {
            let isLiveError = false;
            this.spinner.show();
            this.submitted = true;
            this.proctorService.getSessionToken(this.globals.root_url, this.localData['usercode'], student_id, this.localExam['exam_id'])
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            document.getElementsByTagName('body')[0].style.overflow = "hidden";
                            let livevideo = document.getElementById('livevideo');
                            livevideo.style.display = 'block';
                            // if(data.os_name != 'android')
                            //  {
                            this.TOKEN = data.token;
                            this.SESSION_ID = data.session_id;
                            let vcsetting = {'sid':data.session_id, 'tid':data.token};
                            localStorage.setItem('pkshn_ls_setting',JSON.stringify(vcsetting));                            
                            // }
                            //  else
                            //  {
                            //    this.TOKEN = "T1==cGFydG5lcl9pZD00NjIzOTIwMiZzaWc9ZGY2NDU2OWYzNGEwMDI2Njc4Mjc2NGEwMjdhYTFjNTQ2MThiZjY0NTpzZXNzaW9uX2lkPTJfTVg0ME5qSXpPVEl3TW41LU1UVTFPVE14TURZMU9EZzRPWDVCZEdad0swWTFNbkYzWTJRM05WcFVSalJUTm5CYWIwaC1RWDQmY3JlYXRlX3RpbWU9MTU1OTMxMDYzMCZub25jZT0wLjg2MzA1NTEzNDI1NDU4NiZyb2xlPXB1Ymxpc2hlciZleHBpcmVfdGltZT0xNTU5Mzk3MDMwJmluaXRpYWxfbGF5b3V0X2NsYXNzX2xpc3Q9";
                            //     this.SESSION_ID = "2_MX40NjIzOTIwMn5-MTU1OTMxMDY1ODg4OX5BdGZwK0Y1MnF3Y2Q3NVpURjRTNnBab0h-QX4";
                            //  }
                            //let TOKEN = "T1==cGFydG5lcl9pZD00NjIzOTIwMiZzaWc9ZGY2NDU2OWYzNGEwMDI2Njc4Mjc2NGEwMjdhYTFjNTQ2MThiZjY0NTpzZXNzaW9uX2lkPTJfTVg0ME5qSXpPVEl3TW41LU1UVTFPVE14TURZMU9EZzRPWDVCZEdad0swWTFNbkYzWTJRM05WcFVSalJUTm5CYWIwaC1RWDQmY3JlYXRlX3RpbWU9MTU1OTMxMDYzMCZub25jZT0wLjg2MzA1NTEzNDI1NDU4NiZyb2xlPXB1Ymxpc2hlciZleHBpcmVfdGltZT0xNTU5Mzk3MDMwJmluaXRpYWxfbGF5b3V0X2NsYXNzX2xpc3Q9"; //data.token;
                            //let TOKEN = data.token;
                            //let SESSION_ID = "2_MX40NjIzOTIwMn5-MTU1OTMxMDY1ODg4OX5BdGZwK0Y1MnF3Y2Q3NVpURjRTNnBab0h-QX4";//data.session_id;
                            //let SESSION_ID = data.session_id;

                            /*                        this.opentokService.initSession(this.sessionid, this.token);
                                                    const OT = this.opentokService.getOT();
                                                    this.publisher = OT.initPublisher(this.publisherDiv.nativeElement, {insertMode: 'append',width:50, height:40});
                                                    this.globals.publisherObj = this.publisher;
                                                    if (this.session) {
                                                      if (this.session['isConnected']()) {
                                                        this.publish();
                                                      }
                                                      this.session.on('sessionConnected', () => this.publish());
                                                    }*/

                            /*this.opentokService.initSession(this.TOKEN, this.SESSION_ID).then((session: OT.Session) => {
                            //this.opentokService.initSession('46239202', this.SESSION_ID).then((session: OT.Session) => {
                                this.session = session;
                                this.session.on('streamCreated', (event) => {
                                    console.log('connect stream');
                                    this.streams.push(event.stream);
                                    this.subscriber = this.session.subscribe(event.stream, this.subscriberDiv.nativeElement, {}, (err) => {
                                        if (err) {
                                            console.log(err.message);
                                        }
                                        else{
                                            console.log('connect subscriber');
                                        }
                                    });
                                    this.changeDetectorRef.detectChanges();
                                });
                                this.session.on('streamDestroyed', (event) => {
                                    const idx = this.streams.indexOf(event.stream);
                                    if (idx > -1) {
                                        this.streams.splice(idx, 1);
                                        this.changeDetectorRef.detectChanges();
                                    }
                                });
                            })
                                .then(() => this.opentokService.connect())
                                .catch((err) => {
                                    if (err) {
                                        console.log(err.message);
                                        this.globals.statusOpen(err.message);
                                    }
                                    else
                                    {
                                        console.log('conect publisher');
                                    }
                                });*/

                        }
                        else if (data.status == 'COM_TOKEN_ERROR') {
                            this.loading = false;
                            this.router.navigateByUrl('/login');
                        }
                        else {
                            this.loading = false;
                            this.globals.statusOpen(data.status);
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
        }
    }

    public liveModalClose(modal_id: string) {
        document.getElementsByTagName('body')[0].style.overflow = "auto";
        let modal = document.getElementById(modal_id);
        // if (this.subscriber != null){
        //     this.session.unsubscribe(this.subscriber);
        // }
        this.session.disconnect()
        // this.session.cleanUpDom();
        this.session.off()



        // this.session.on('streamDestroyed', (event) => {
        //     const idx = this.streams.indexOf(event.stream);
        //     if (idx > -1) {
        //         this.streams.splice(idx, 1);
        //         this.changeDetectorRef.detectChanges();
        //     }
        // });

        modal.style.display = 'none';
      

    }

    public gallery(entity_id: number, gallary_type: string) {
        this.spinner.show();
        this.submitted = true;
        this.proctorService.getVideoGallary(this.globals.root_url, this.localData['usercode'], entity_id, gallary_type, this.localData['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.vidalbum = data.album;

                        console.log(this.vidalbum)

                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else {
                        this.loading = false;
                        this.globals.statusOpen(data.status);
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
    }

    public back() {
        let batch_id = window.btoa(this.batchid)
        this.router.navigateByUrl('/exams-link/' + batch_id);

    }
    ngOnDestroy() {
        // this.subscriberDiv.unsubscribe()
    }
    public goToLink(studnetid,examid){ 
        //console.log(examid);
        this.exam_id = this.localExam['exam_id'];
    window.open('https://mypanel.pareekshn.com/ams/proctoring.html?id='+studnetid+','+this.exam_id+' ','_blank',"width=600,height=600,fullscreen=0");
    }

}


